<script>
import iCompetition from './_competition.js';
import matchEntity from './MatchEntity.vue';

export default {
  name: 'pool',

  mixins: [iCompetition],

  data() {
    return {
      home_url: home_url,
      referrer: referrer,
      competition_id: competition_id,
      competition: [],
      results: [],
      rounds: [],
      pool_id: pool_id,
      pool: [],
      event: null,
      isLoading: true,
      isLoadingEvent: true,
    }
  },

  components: {
    matchEntity,
  },

  template: `
    <div class="dash-public-plugin-container dash-public-plugin-pool" v-bind:class="{'is-loading': isLoading, 'is-scrollable': true}">
        <div class="dash-public-plugin-container-header is-tab">
          <div>
            <div v-if="referrer">
              <button class="go-back" onclick="history.back(-1)">Go back</button>
            </div>
            <div v-else>
              <a class="go-back" :href="home_url + '/competitions/' + competition_id">Go back</a>
            </div>
          </div>
          
          <div class="header-row">
            <div class="header-title">{{ competition.display_name }}</div>
            <div class="header-actions"></div>
          </div>

          <div class="header-row">
            <div class="header-meta">
              <div v-if="pool.title">Pool - {{ pool.title }}</div>
              <div v-if="event">{{ event.start_date | formatDate }}</div>
            </div>
          </div>

          <nav class="container-tabs-nav">
            <a aria-pressed="true">Teams</a>
            <a aria-pressed="false"><span class="show-md">Pool</span> Information</a>
            <a aria-pressed="false">Matches</a>
          </nav>
        </div>

        <div class="dash-public-plugin-container-content is-tab">
          <div class="container-tabs">
            <div class="tab" aria-expanded="true">
              <div v-if="pool.pool_teams"class="dash-list-items">
                <div class="dash-list-item"
                  v-for="team in pool.pool_teams"
                  v-bind:key="team.key">
                  <div class="item-content">
                    <match-entity
                      :entity="team"
                      :rounds="rounds"
                      :results="results"
                      :match="[]"
                      :isEntityA="false"
                      :isHome="false">
                    </match-entity>
                  </div>
                </div>
              </div>
              <div v-else>No pool entries found.</div>
            </div>
            
            <div class="tab" aria-expanded="false">
              <div v-if="event">
                <h4>
                  <a :href="home_url + '/events/' + event.id"><span>{{ event.title }}</span> &nbsp;
                    <i class="fas fa-external-link"></i></a>
                </h4>
                
                <ul class="meta-items">
                  <li>
                    <i class="icon far fa-fw fa-map-marker-minus"></i>
                    {{ event.location }}
                  </li>
                  <li>
                    <i class="icon far fa-fw fa-calendar-alt"></i> {{ event.start_date | formatDate }}
                    <span v-if="event.end_date"> - {{ event.end_date | formatDate }}</span>
                  </li>
                </ul>
              </div>

              <p v-else>No details available for this event.</p>
            </div>

            <div class="tab is-collapsed" aria-expanded="false">
              <div class="competition-container">
              </div>
            </div>
          </div>
        </div>
    </div>
  `,

  mounted() {
    const $this = this;

    console.log($this);

    this.getCompetition(competition_id, function (competition, results) {
      $this.competition = competition;
      $this.results = results;
      $this.rounds = $this.getRoundsFromCompetition(competition);
      $this.pool = $this.getPoolByKey(pool_id, $this.rounds);

      $this.isLoading = false;

      $this.getRoundEvent($this.pool, function (event) {
        $this.event = event;
        $this.isLoadingEvent = false;
      });
    });
  }
}
</script>

<style scoped>

</style>
